import { registerPhaseOneSeries } from "./SeriesRegistry";
export function initRegistry() {
    registerPhaseOneSeries();
}
initRegistry();
